"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpreadSide = exports.CoverageType = void 0;
exports.default = getCoverageType;
var CoverageType;
(function (CoverageType) {
  CoverageType["FULL"] = "full";
  CoverageType["LEFT"] = "left";
  CoverageType["RIGHT"] = "right";
})(CoverageType || (exports.CoverageType = CoverageType = {}));
var SpreadSide;
(function (SpreadSide) {
  SpreadSide["LEFT"] = "left";
  SpreadSide["RIGHT"] = "right";
})(SpreadSide || (exports.SpreadSide = SpreadSide = {}));
function getCoverageType(printable, layerId) {
  let activePage = CoverageType.FULL;
  const isPartial = printable === null || printable === void 0 ? void 0 : printable.isCompositeDesign;
  if (isPartial && layerId) {
    activePage = layerId.includes('--SHIFTED') ? CoverageType.RIGHT : CoverageType.LEFT;
  } else if (isPartial) {
    activePage = CoverageType.LEFT;
  }
  return activePage;
}